<!-- <div *ngIf="loading">
    <i class="pi pi-cog pi-spin" style="font-size: 2rem;"></i>
</div> -->
<div style="width: 100%;">
    <p-panel [ngStyle]="{'width':'100%'}" [showHeader]="false">
        <div
            style="display: flex; flex-direction: column; align-items: center; gap:8px; justify-content: center; width: 100%;">
            <img class="bounce" src="../../assets/img/ptcoins.svg" alt="PT Coins"
                style="width: 150px; height: 150px;" />


            <div *ngIf="ready" style="font-size: 24px; text-align: center;">
                Hai guadagnato <b>{{ptPrize}}</b> Punti Tempo
                rispondendo correttamente a <b>{{correct}}</b> {{correct==1 ?
                'domanda' :
                'domande'}} su <b>{{t.numQuest}}</b>!</div>

            <div *ngIf="ready" style="margin-top: 16px;">
                

                <ion-button expand="block" (click)="done()" style="margin-top: 32px; font-size: 1.1rem;">
                    <ion-label>Accetta</ion-label>
                </ion-button>
                <ion-button expand="block" *ngIf="canRetry" (click)="goBack()" fill="clear"
                    style="margin-top: 8px; font-size: 1.1rem">
                    <ion-label>Ritenta</ion-label>
                </ion-button>
            </div>



        </div>

    </p-panel>
</div>
<!-- <p-button (onClick)="again()" label="AGAIN!" /> -->